import type { GetBannersRequest } from './types';

export const BANNER_QUERY_KEYS = {
  default: () => ['banners'] as const,
  getBanners: (params?: GetBannersRequest) => [...BANNER_QUERY_KEYS.default(), params] as const,
};
